export enum CalendarViewTypes {
  'Month' = 'Month',
  'Week' = 'Week',
  'Day' = 'Day',
}

export enum PacingPlanReasons {
  'Reteach Yesterday’s Standard' = 'Reteach Yesterday’s Standard',
  'Reteach Standard of Choice' = 'Reteach Standard of Choice',
}
